const DEFAULT_BOX_SIZE = 0.0001797 * 10;
const DEFAULT_AUTO_RADIUS_KM = 0.13;
const GEO_GRID_LAT_BASE = 14.5408;
const GEO_GRID_LNG_OFFSET = 118.2689;
const GEO_FALLBACK = ["Geocerca_automatica_", 1, ""];
const CLASSIFIED_TYPES = new Set([2, 3, 4, "2", "3", "4"]);

function readNumber(value) {
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
}

function isPoint(point) {
  return (
    Array.isArray(point) &&
    point.length >= 2 &&
    readNumber(point[0]) != null &&
    readNumber(point[1]) != null
  );
}

function isClassifiedType(value) {
  return CLASSIFIED_TYPES.has(value);
}

export function getKm(lat1, lon1, lat2, lon2) {
  lat1 = readNumber(lat1);
  lon1 = readNumber(lon1);
  lat2 = readNumber(lat2);
  lon2 = readNumber(lon2);
  if (lat1 == null || lon1 == null || lat2 == null || lon2 == null) {
    return Number.POSITIVE_INFINITY;
  }

  const radiusKm = 6371;
  const dLat = (lat2 - lat1) * (Math.PI / 180);
  const dLon = (lon2 - lon1) * (Math.PI / 180);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * (Math.PI / 180)) *
      Math.cos(lat2 * (Math.PI / 180)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return radiusKm * c;
}

export function pointInPolygon(point, polygon) {
  if (!isPoint(point) || !Array.isArray(polygon) || polygon.length < 3) {
    return false;
  }

  const x = readNumber(point[0]);
  const y = readNumber(point[1]);
  let inside = false;

  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    if (!isPoint(polygon[i]) || !isPoint(polygon[j])) {
      continue;
    }
    const xi = readNumber(polygon[i][0]);
    const yi = readNumber(polygon[i][1]);
    const xj = readNumber(polygon[j][0]);
    const yj = readNumber(polygon[j][1]);
    const intersect =
      yi > y != yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
    if (intersect) {
      inside = !inside;
    }
  }

  return inside;
}

export function collectNearbyGeofenceIds(lat, lng, geosMap, boxSize = DEFAULT_BOX_SIZE) {
  lat = readNumber(lat);
  lng = readNumber(lng);
  if (lat == null || lng == null || !geosMap || typeof geosMap !== "object") {
    return [];
  }

  const p = Math.floor((lat - GEO_GRID_LAT_BASE) / boxSize);
  const q = Math.floor((lng + GEO_GRID_LNG_OFFSET) / boxSize);
  const keyCloseList = [
    p + "_" + q,
    p + "_" + (q + 1),
    p + "_" + (q - 1),
    p + 1 + "_" + q,
    p - 1 + "_" + q,
    p + 1 + "_" + (q + 1),
    p - 1 + "_" + (q - 1),
    p + 1 + "_" + (q - 1),
    p - 1 + "_" + (q + 1),
  ];
  const geosAround = [];

  for (const key of keyCloseList) {
    const ids = geosMap[key];
    if (!Array.isArray(ids)) {
      continue;
    }
    for (const id of ids) {
      if (!geosAround.includes(id)) {
        geosAround.push(id);
      }
    }
  }

  return geosAround;
}

export function searchGeofence(lat, lng, context = {}) {
  const geosMap = context.geosMap || {};
  const poli = context.poli || {};
  const geos = Array.isArray(context.geos) ? context.geos : [];
  const geosClass = context.geosClass || {};
  const boxSize = context.boxSize || DEFAULT_BOX_SIZE;
  const autoRadiusKm = context.autoRadiusKm || DEFAULT_AUTO_RADIUS_KM;
  const classifiedOnly = context.classifiedOnly === true;
  const geosAround = collectNearbyGeofenceIds(lat, lng, geosMap, boxSize);

  for (const id in poli) {
    if (!geosAround.includes(id)) {
      continue;
    }
    const polygon = poli[id];
    if (
      !Array.isArray(polygon) ||
      (classifiedOnly && !isClassifiedType(polygon[2])) ||
      !pointInPolygon([lat, lng], polygon[0])
    ) {
      continue;
    }
    return [polygon[1], 2, id];
  }

  for (const geo of geos) {
    if (!Array.isArray(geo) || !geosAround.includes(geo[0])) {
      continue;
    }
    const points = Array.isArray(geo[1]) ? geo[1] : [];
    for (const point of points) {
      if (!isPoint(point)) {
        continue;
      }
      if (getKm(lat, lng, point[0], point[1]) <= autoRadiusKm) {
        if (typeof geosClass[geo[0]] == "undefined") {
          if (classifiedOnly) {
            continue;
          }
          return ["Geocerca_automatica-" + geo[0].split("-")[0], 1, geo[0]];
        }
        if (classifiedOnly && !isClassifiedType(geosClass[geo[0]][1])) {
          continue;
        }
        return [geosClass[geo[0]][0], geosClass[geo[0]][1], geo[0]];
      }
    }
  }

  return [...GEO_FALLBACK];
}